import { MarkdownEditor, MarkdownEditorProps } from 'components'
import { TextFontWeight } from 'types'
import { SViewProps } from '.'
import { useScale } from '../../utils/scaleUtils'
import { useExplorerConfig } from '../providers'
import SView from './SView'

export interface Props extends MarkdownEditorProps {
  /** (default white) */
  color?: string
  containerProps?: SViewProps
  /** remove scroll and fix height to content */
  noScroll?: boolean
  /** (default 18) */
  bodySize?: number
  baseWeight?: TextFontWeight
}

export default function SMarkdown({
  baseWeight,
  bodySize = 18,
  color,
  containerProps,
  noScroll,
  ...rest
}: Props) {
  const { theme } = useExplorerConfig()
  const scale = useScale()
  const fontFamily = theme?.fontFamily
  const spacing = 0.6 * bodySize * scale

  const makeStyleProps = (size: number) => {
    const fontSize = `${scale * size}px`
    const lineHeight = `${fontSize + 0.4 * bodySize * scale}px`
    return { fontFamily, fontSize, lineHeight }
  }

  return (
    <SView
      {...containerProps}
      overflow={noScroll ? 'hidden' : 'auto'}
      css={{
        '& > div': {
          flex: 'none', // override default flex: 1
        },
        '& .mdxeditor-contenteditable': {
          ...(color && { color }),
          userSelect: 'none !important',
          padding: 0,
          ...makeStyleProps(bodySize),
          '& > *': {
            fontWeight: baseWeight,
            marginBottom: spacing,
            '&:last-child': {
              marginBottom: 0,
            },
          },
          '& p': makeStyleProps(bodySize),
          '& h1': makeStyleProps(54),
          '& h2': makeStyleProps(42),
          '& h3': makeStyleProps(32),
          '& h4': makeStyleProps(24),
          '& h5': makeStyleProps(14),
          '& h6': makeStyleProps(12),
        },
        ...containerProps?.css,
      }}
    >
      <MarkdownEditor readOnly {...rest} />
    </SView>
  )
}
